import { motion } from 'framer-motion';

export default function AboutSection() {
  const highlights = [
    { icon: 'ri-shield-check-line', text: 'CE, TSE ve ISO 9001 Sertifikalı' },
    { icon: 'ri-team-line', text: '50+ Uzman Teknik Kadro' },
    { icon: 'ri-map-pin-line', text: 'Türkiye Genelinde Hizmet' },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="w-full h-64 rounded-2xl overflow-hidden">
                  <img
                    src="https://public.readdy.ai/ai/img_res/5cb380191aa1da6017b877c5a48806fd.jpg"
                    alt="Yangın güvenlik uzmanı"
                    title="Yangın algılama sistemi kurulum uzmanı"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-full h-40 rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Close%20up%20of%20modern%20fire%20alarm%20control%20panel%20with%20digital%20display%20and%20LED%20indicators%2C%20professional%20safety%20equipment%2C%20clean%20background%2C%20product%20photography&width=400&height=300&seq=about-img2-v2&orientation=landscape"
                    alt="Yangın alarm kontrol paneli"
                    title="Yangın alarm kontrol paneli detay"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              <div className="pt-8 space-y-4">
                <div className="w-full h-40 rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Team%20of%20fire%20safety%20professionals%20in%20meeting%20room%20discussing%20project%20plans%2C%20corporate%20environment%2C%20modern%20office%2C%20warm%20professional%20lighting&width=400&height=300&seq=about-img3-v2&orientation=landscape"
                    alt="Yangın güvenlik ekibi"
                    title="Profesyonel yangın güvenlik ekibi"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-full h-40 rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20technician%20installing%20white%20circular%20smoke%20detector%20on%20ceiling%20in%20modern%20building%20interior%2C%20hands%20working%20with%20precision%20tools%2C%20clean%20minimal%20white%20background%2C%20professional%20installation%20photography%20with%20warm%20natural%20lighting&width=400&height=500&seq=about-img4-updated-v1&orientation=portrait"
                    alt="Duman sensörü kurulumu"
                    title="Duman sensörü profesyonel kurulum"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>

            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
              className="absolute -bottom-6 -right-4 bg-red-600 text-white rounded-2xl p-5 shadow-xl"
            >
              <p className="text-3xl font-bold">15+</p>
              <p className="text-sm text-red-100">Yıllık Deneyim</p>
            </motion.div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="text-sm font-semibold text-red-600 tracking-wider uppercase">
              Hakkımızda
            </span>
            <h4 className="text-3xl lg:text-4xl font-bold text-gray-900 mt-3 mb-6">
              <a href="#" className="cursor-default">
                Yangın Güvenliğinde Öncü,{' '}
                <span className="text-red-600">Güvenilir Partner</span>
              </a>
            </h4>
            <p className="text-gray-600 leading-relaxed mb-6">
              2009 yılından bu yana yangın algılama ve ihbar sistemleri alanında
              faaliyet gösteren firmamız, Türkiye genelinde 2.350'den fazla
              başarılı kurulum gerçekleştirmiştir. Bosch, Siemens, Honeywell gibi
              dünya markalarının yetkili distribütörü olarak en kaliteli ürünleri
              sunuyoruz.
            </p>
            <p className="text-gray-600 leading-relaxed mb-8">
              Uzman mühendis kadromuz, projelendirmeden kuruluma, bakımdan 7/24
              teknik desteğe kadar tüm süreçlerde yanınızda. Müşteri memnuniyetini
              her şeyin üstünde tutarak, güvenliğiniz için en iyi çözümleri
              üretiyoruz.
            </p>

            <div className="space-y-4 mb-8">
              {highlights.map((item, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.2 + i * 0.1 }}
                  className="flex items-center gap-3"
                >
                  <div className="w-8 h-8 flex items-center justify-center bg-red-100 rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-red-600`}></i>
                  </div>
                  <span className="text-gray-800 font-medium text-sm">{item.text}</span>
                </motion.div>
              ))}
            </div>

            <a
              href="#iletisim"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-red-600 text-white font-semibold rounded-full hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Bizimle İletişime Geçin
              <i className="ri-arrow-right-line"></i>
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
